import { InMemoryEntityModel } from "../in-memory-entity-model.js";
export class SimpleAsyncQueryableObservableEntityModel extends InMemoryEntityModel {
    model;
    queries = {};
    reverseQueries = new Map();
    constructor(queryableModel) {
        super();
        this.model = queryableModel;
    }
    async addQuery(queryIri) {
        if (this.queries[queryIri]) {
            // Do nothing, because the query is present
            return;
        }
        const result = await this.model.query(queryIri);
        if (this.queries[queryIri]) {
            // Do nothing, because the query is present
            return;
        }
        this.queries[queryIri] = result;
        const ids = Object.keys(result);
        const addedIds = {};
        for (const id of ids) {
            if (!this.reverseQueries.has(id)) {
                this.reverseQueries.set(id, []);
            }
            const queries = this.reverseQueries.get(id);
            if (!queries.includes(queryIri)) {
                if (queries.length == 0) {
                    addedIds[id] = result[id];
                }
                queries.push(queryIri);
            }
        }
        this.change(addedIds, []);
    }
    async releaseQuery(queryIri) {
        if (!this.queries[queryIri]) {
            // Do nothing, because the query is not present
            return;
        }
        const ids = Object.keys(this.queries[queryIri]);
        const removedIds = [];
        for (const id of ids) {
            let queries = this.reverseQueries.get(id);
            queries = queries.filter(q => q !== queryIri);
            if (queries.length === 0) {
                this.reverseQueries.delete(id);
                removedIds.push(id);
            }
            else {
                this.reverseQueries.set(id, queries);
            }
        }
        delete this.queries[queryIri];
        this.change({}, removedIds);
    }
}
//# sourceMappingURL=implementation.js.map